import React from 'react';
import { FormButtonsContainer, FormSubmitButton } from '../Shared/Forms/Forms';
import { Container, Error } from './styled';

type ErrorBoundaryFallbackUIProps = {
  width?: string;
  height?: string;
};

export const ErrorBoundaryFallbackUI = ({ width, height }: ErrorBoundaryFallbackUIProps) => {
  return (
    <Container width={width} height={height}>
      <Error>Uh-oh! Looks like something didn’t go quite right. Please try again!</Error>
      <FormButtonsContainer style={{ width: '120px' }} noBorderTop>
        <FormSubmitButton
          onClick={() => {
            window.location.replace('/app');
            requestAnimationFrame(() => {
              window.location.href = '/app';
            });
          }}
        >
          Refresh
        </FormSubmitButton>
      </FormButtonsContainer>
    </Container>
  );
};
